import useAxios from '../../utils/useAxios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { rejectWithApiError } from '../../utils/reduxErrors'
import { notifyError } from '../../utils/appToasts'

export const hasCalcItems = (entry) =>
  Array.isArray(entry?.items) &&
  entry.items.length > 0 &&
  entry.items.every((item) => item && typeof item.name === 'string')

const readStoredCalc = () => {
  const raw = localStorage.getItem('calc')
  if (raw === null) return []

  let parsed
  try {
    parsed = JSON.parse(raw)
  } catch (error) {
    parsed = null
  }

  const valid = Array.isArray(parsed) ? parsed.filter(hasCalcItems) : []
  if (!Array.isArray(parsed) || valid.length !== parsed.length) {
    localStorage.setItem('calc', JSON.stringify(valid))
    notifyError('Некорректные записи расчёта КП удалены. Корзина не затронута.')
  }
  return valid
}

export const getOrders = createAsyncThunk('orders/get', async (...args) => {
  try {
    const axios = useAxios()
    const { data } = await axios.get('/api/orders/')
    return data
  } catch (error) {
    const { rejectWithValue } = args[1]
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const saveOrder = createAsyncThunk('order/save', async (t, { rejectWithValue }) => {
  try {
    const axios = useAxios()
    const config = { headers: { 'content-type': 'multipart/form-data' } }
    const { data } = await axios.put(`/api/orders/${t.id}/`, t, config)
    return data
  } catch (error) {
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const createOrder = createAsyncThunk('order/create', async (t, { rejectWithValue }) => {
  try {
    const axios = useAxios()
    const { data } = await axios.post('/api/orders/', t)
    return data
  } catch (error) {
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const deleteOrder = createAsyncThunk('order/delete', async (t, { rejectWithValue }) => {
  try {
    const axios = useAxios()
    const { data } = await axios.delete(`/api/orders/${t.id}/`)
    return data
  } catch (error) {
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const addToCart = createAsyncThunk('order/addtocart', async (item, { rejectWithValue }) => {
  const cartItems = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : []
  cartItems.push(item)
  try {
    localStorage.setItem('cart', JSON.stringify(cartItems))
  } catch (error) {
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const removeFromCart = createAsyncThunk(
  'order/removefromcart',
  async (index, { rejectWithValue }) => {
    const cartItems = JSON.parse(localStorage.getItem('cart'))
    cartItems.splice(index, 1)
    try {
      localStorage.setItem('cart', JSON.stringify(cartItems))
    } catch (error) {
      return rejectWithApiError(rejectWithValue, error)
    }
  },
)

export const emptyCart = createAsyncThunk('order/emptycart', async (...args) => {
  try {
    localStorage.setItem('cart', JSON.stringify([]))
  } catch (error) {
    const { rejectWithValue } = args[1]
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const getCart = createAsyncThunk('order/getcart', async (...args) => {
  try {
    const data = JSON.parse(localStorage.getItem('cart'))
    if (!data) return []
    return data
  } catch (error) {
    const { rejectWithValue } = args[1]
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const addToCalc = createAsyncThunk('order/addtocalc', async (item, { rejectWithValue }) => {
  try {
    if (!hasCalcItems(item)) {
      return rejectWithValue('Расчёт не содержит товаров. Выберите обрамление или фурнитуру.')
    }
    const calcItems = readStoredCalc()
    calcItems.push(item)
    localStorage.setItem('calc', JSON.stringify(calcItems))
  } catch (error) {
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const removeFromCalc = createAsyncThunk(
  'order/removefromcalc',
  async (index, { rejectWithValue }) => {
    const calcItems = JSON.parse(localStorage.getItem('calc'))
    calcItems.splice(index, 1)
    try {
      localStorage.setItem('calc', JSON.stringify(calcItems))
    } catch (error) {
      return rejectWithApiError(rejectWithValue, error)
    }
  },
)

export const emptyCalc = createAsyncThunk('order/emptycalc', async (...args) => {
  try {
    localStorage.setItem('calc', JSON.stringify([]))
  } catch (error) {
    const { rejectWithValue } = args[1]
    return rejectWithApiError(rejectWithValue, error)
  }
})

export const getCalc = createAsyncThunk('order/getcalc', async (...args) => {
  try {
    return readStoredCalc()
  } catch (error) {
    const { rejectWithValue } = args[1]
    return rejectWithApiError(rejectWithValue, error)
  }
})
